import type { Map as MapBoxMap } from 'mapbox-gl';
import type mapboxGL from 'mapbox-gl';

import {
    debug as FallbackDebug,
    type DebugHelper,
} from '@gebruederheitz/debuggable';
import { GameApi } from 'urban-challenger-sdk';

import './style.scss';
// import { readMarkerDataFromDom } from './markers-from-dom';
import { GameMap } from './game-map';
import { ApiState, GamePOIType } from 'urban-challenger-sdk';

declare global {
    export interface Window {
        mapboxgl?: typeof mapboxGL;
        map?: HTMLDivElement;
        ucMapboxMap?: MapBoxMap;
        __debug?: MapBoxMap;
    }
}

export async function init(
    globalDebug: DebugHelper = FallbackDebug
): Promise<void> {
    const debug = globalDebug.spawn('mapbox-control', 'MapBoxControl');
    debug.log('init');
    const gameMap = new GameMap(debug);
    const sdk = GameApi.get(process.env.NODE_ENV);

    let game: ApiState['game'];
    const derived = await sdk.getDerivedState((s: ApiState) => s.game);
    derived.subscribe((s) => {
        game = s;
    });

    // Fallback in case we never receive an API state, after 5s we resolve.
    const apiInit = Promise.race([sdk.ready(), debug.timeout(5000)]);

    try {
        await gameMap.useExistingMap();
        // const { initialFeatures, challengeMap } = readMarkerDataFromDom();
        // debug.log({ initialFeatures, challengeMap });
        // gameMap.setChallenges(challengeMap);
        gameMap.setState(sdk);
    } catch (e) {
        // no location data, or no initialized map
        await gameMap.initCustomMap();
        const challenges = new Map();
        gameMap.setChallenges(challenges).setState(sdk);
        gameMap.setState(sdk).autoUpdateChallenges();
    }

    await apiInit;
    debug.log('adding pois to map');
    if (game?.poi.length) {
        debug.log('start');
        const start = game.poi.find((i) => i.type === GamePOIType.Start);
        const finish = game.poi.find((i) => i.type === GamePOIType.Finish);

        await gameMap.addStartFinish(start, finish);

        await gameMap.addGenericPoi(
            game.poi.filter((p) => p.type === GamePOIType.Generic)
        );
    }
}
